import { useEffect, useState } from "react";
import api from "@/lib/api";
import { gbp } from "./constants";

export default function Dashboard({ onGo }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/admin/dashboard").then(({ data }) => setData(data));
    }, []);
    if (!data) return <div className="loading">Loading…</div>;
    const { counts, recent_orders, pending_submissions } = data;

    const stat = (label, value) => (
        <div style={{ padding: 24, background: "var(--parchment-soft)", border: "1px solid var(--sand-line)" }}>
            <div className="eyebrow" style={{ marginBottom: 8 }}>{label}</div>
            <div style={{ fontFamily: "var(--font-serif)", fontSize: "2rem", color: "var(--cocoa)" }}>{value}</div>
        </div>
    );

    return (
        <div data-testid="admin-dashboard">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 16, marginBottom: 32 }}>
                {stat("Revenue", gbp(counts.revenue_total))}
                {stat("Orders", counts.orders_paid)}
                {stat("Pending consignments", counts.submissions_pending)}
                {stat("Live pieces", counts.products_live)}
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 32 }}>
                <div>
                    <h3 style={{ fontFamily: "var(--font-serif)", fontStyle: "italic", fontSize: "1.4rem", margin: "0 0 12px" }}>Recent orders</h3>
                    {recent_orders.length === 0 && <div className="empty-state" style={{ padding: 20 }}>No orders yet.</div>}
                    {recent_orders.map((o) => (
                        <div key={o.id} style={{ padding: "12px 0", borderBottom: "1px solid var(--sand-line)", display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <div style={{ fontFamily: "var(--font-serif)" }}>{o.email}</div>
                                <div style={{ fontSize: 11, color: "var(--sand)", letterSpacing: "0.24em", textTransform: "uppercase" }}>
                                    {(o.line_items || []).map((li) => li.designer).join(" · ") || "—"}
                                </div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                                <div>{gbp(o.total)}</div>
                                <span className={`status-pill ${o.status}`}>{o.status}</span>
                            </div>
                        </div>
                    ))}
                </div>
                <div>
                    <h3 style={{ fontFamily: "var(--font-serif)", fontStyle: "italic", fontSize: "1.4rem", margin: "0 0 12px" }}>Pending consignments</h3>
                    {pending_submissions.length === 0 && <div className="empty-state" style={{ padding: 20 }}>Nothing awaiting review.</div>}
                    {pending_submissions.map((s) => (
                        <div key={s.id} style={{ padding: "12px 0", borderBottom: "1px solid var(--sand-line)" }}>
                            <div style={{ fontFamily: "var(--font-serif)" }}>{s.full_name}</div>
                            <div style={{ fontSize: 11, color: "var(--sand)", letterSpacing: "0.24em", textTransform: "uppercase" }}>
                                {s.items?.length} piece{s.items?.length === 1 ? "" : "s"}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <button className="btn" onClick={() => onGo("listings")} data-testid="dash-add-product">Add product</button>
                <button className="btn btn-outline" onClick={() => onGo("submissions")}>Review submissions</button>
                <button className="btn btn-outline" onClick={() => onGo("content")}>Edit content</button>
            </div>
        </div>
    );
}
